// extracted by mini-css-extract-plugin
export default {"permissionSelector":"styles_permissionSelector__mAtKy","permissionOptions":"styles_permissionOptions__zWXYg"};